import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { ELLIPSIS } from './getPageNumbers'

const BASE = 'tw:flex tw:items-center tw:justify-center tw:h-8 tw:px-3 tw:text-sm '
  + 'tw:font-medium tw:border-r tw:border-solid tw:border-gray-300 '
  + 'tw:last:border-r-0'
const ACTIVE = 'tw:bg-gray-100 tw:text-ds-neutral-highest'
const INACTIVE = 'tw:bg-white tw:text-gray-500 tw:hover:bg-gray-100'

const PageButton = ({ page, isActive = false, onClick, disabled = false }) => {
  const handleClick = useCallback(() => onClick(page), [onClick, page])

  if (page === ELLIPSIS) {
    return (
      <span className={`${BASE} tw:bg-white tw:text-gray-500 tw:cursor-default`}>
        {ELLIPSIS}
      </span>
    )
  }

  const stateClasses = isActive ? ACTIVE : INACTIVE
  const className = `${BASE} ${stateClasses} tw:border-0 tw:cursor-pointer `
    + 'tw:disabled:opacity-50 tw:disabled:cursor-not-allowed'

  return (
    <button
      className={className}
      disabled={disabled}
      type="button"
      onClick={handleClick}
    >
      {page}
    </button>
  )
}

PageButton.propTypes = {
  disabled: PropTypes.bool,
  isActive: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  page: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
}

PageButton.defaultProps = {
  disabled: false,
  isActive: false
}

export default PageButton
